import { createGlobalStyle } from 'styled-components';

import colors from './colors';

export const GlobalStyles = createGlobalStyle`
  :root {
    font-size: 16px;
  }
  
  * {
    font-family: Sarabun;

    h1, h2, h3, h4, h5, h6, 
    .ant-page-header-heading-title {
      font-family: Nunito;
    }
  }
  
  body {
    background-color: ${colors.background};
  }

  // ant.design overwrites
  .ant-input-affix-wrapper.ant-input-affix-wrapper-disabled:hover {
    border-color: ${colors.lightGray};
  }

  .ant-drawer.drawer-file {
    .ant-drawer-content-wrapper .ant-drawer-content {
      .ant-drawer-body {
        padding-bottom: 0 !important;
        padding-top: 0 !important;
      }
    }
  }
`;
